const queryOptions = (t) => [
  {
    name: 'createdAt',
    displayName: t('chartQueryBuilder.queryOptions.queryOptions.date'),
    type: 'date',
    used: false,
    value: ''
  },
  {
    name: 'orderId',
    displayName: t('chartQueryBuilder.queryOptions.queryOptions.orderId'),
    type: 'string',
    used: false,
    value: ''
  },
  {
    name: 'fullName',
    displayName: t('chartQueryBuilder.queryOptions.queryOptions.fullName'),
    type: 'string',
    used: false,
    value: ''
  },
  {
    name: 'emailAddress',
    displayName: t('chartQueryBuilder.queryOptions.queryOptions.emailAddress'),
    type: 'string',
    used: false,
    value: ''
  },
  {
    name: 'schoolName',
    displayName: t('chartQueryBuilder.queryOptions.queryOptions.schoolName'),
    type: 'string',
    used: false,
    value: ''
  },
  {
    name: 'className',
    displayName: t('chartQueryBuilder.queryOptions.queryOptions.className'),
    type: 'string',
    used: false,
    value: ''
  },
  {
    name: 'pagination',
    displayName: '',
    type: 'pagination',
    used: true,
    value: ''
  }
];

export default queryOptions;
